import { forwardRef, type ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
};

const base =
  'inline-flex items-center justify-center rounded-md text-sm font-medium ' +
  'transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ' +
  'focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60';

const variants: Record<Variant, string> = {
  primary: 'bg-primary text-white hover:bg-primary-dark px-4 py-2',
  secondary: 'border border-border bg-bg text-ink hover:bg-bg-soft px-4 py-2',
  ghost: 'text-ink-2 hover:text-ink px-2 py-1',
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', loading = false, fullWidth = false, className = '', children, disabled, ...rest },
  ref,
) {
  const cls = [base, variants[variant], fullWidth ? 'w-full' : '', className].filter(Boolean).join(' ');
  return (
    <button ref={ref} className={cls} disabled={disabled || loading} {...rest}>
      {loading ? 'Working…' : children}
    </button>
  );
});
